<div class="container" *ngIf="location">
    <div class="container">
        <div class="headings">
            <span class="hr"></span>
            <h1 class="text-center">{{location.name}}</h1>
            <span class="hr"></span>
        </div>

        <div class="d-flex justify-content-center">
          <button style="display: block;" *ngIf="authService.user.isAdmin" class="btn btn-danger" (click)="delete()">delete</button>
        </div>

        <div style="height: 20px;"></div>
        <div class="card mb-3" style="padding:10px;">
            <div class="row g-0">
              <div class="col-lg-6">
                <img class="img-fluid" *ngIf="locationImages&&locationImages[0]" [src]="imagesrc+locationImages[0].imagePath" alt="">
              </div>
              <div class="col-lg-6">
                <div class="card-body">
                    <h2>Governorate</h2>
                    <p>{{governerate}}</p>
                    <hr>
                    <h2>Description</h2>
                    <p>{{location.description}}</p>
                    <hr>
                    <h2>Category</h2>
                    <p>{{category}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="headings">
            <span class="hr"></span>
            <h1>Gallery</h1>
            <span class="hr"></span>
        </div>
            <div class="row lastrow">
              <img (click)="myFunc(image)" *ngFor="let image of locationImages" [src]="imagesrc+image.imagePath" alt="" class="col-md-4 img-fluid loop">
            </div>
            <div [ngClass]="{'show': show}" id="add" class="overlay-container  d-flex justify-content-center align-items-center">
              <i (click)="hide()" id="wClose" class="fa  fa-3x fa-window-close"></i>
              <div *ngIf="locationImages" [ngStyle]="{'background-image': 'url('+imagesrc+locationImages[count].imagePath+')'}" class="overlay-inner  d-flex align-items-center justify-content-between">
                <i id="prev" class="fa fa-arrow-circle-left fa-3x" aria-hidden="true" (click)="goleft()"></i>
                <i id="next" class="fa fa-arrow-circle-right fa-3x" aria-hidden="true" (click)="goRight()"></i>
              </div>
            </div>

            <div class="headings">
              <span class="hr"></span>
              <h1>Comments</h1>
              <span class="hr"></span>
          </div>

            <div class="scom">

  
            <div class="input-group mb-3">
              <input *ngIf="this.authService.loggedIn" type="text" class="form-control" placeholder="Enter Comment" aria-label="Recipient's username" [(ngModel)]="postedComment" aria-describedby="basic-addon2">
              <input *ngIf="!this.authService.loggedIn" type="text" class="form-control" placeholder="You Have To Login To Comment" aria-label="Recipient's username" [(ngModel)]="postedComment" aria-describedby="basic-addon2" disabled>
              <div class="input-group-append">
                  <button *ngIf="this.authService.loggedIn" class="btn btn-outline-primary" type="button" (click)="postComment()">Comment</button>
              </div>
              <div class="input-group-append ml-3">
                <button *ngIf="!this.authService.loggedIn" class="btn btn-outline-primary" type="button" disabled (click)="postComment()">Comment</button>
              </div>
            </div>
            <div class="comments" *ngFor="let comment of comments">
              <div class="media">
                <img class="mr-3" src="../../../assets/user.png" alt="Generic placeholder image">
                <div class="media-body">
                  <h3  class="mt-0">{{comment.user.name}}</h3>
                  <div class="comment">
                    {{comment.comment1}}
                  </div>
                </div>
              </div>
            </div>
            </div>
            <br>


</div>